import React from 'react';

const VideaLogo = ({ color }: any) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.95148 14.0785C5.03104 14.0785 5.10889 14.0481 5.16535 13.9921L13.0203 6.26745C13.0879 6.20159 13.1179 6.10856 13.1016 6.01718C13.0854 5.9258 13.0246 5.84841 12.9391 5.80725L4.79835 1.95111C4.66404 1.88772 4.5015 1.92889 4.41767 2.04826L1.74686 5.86241C1.69297 5.93897 1.68099 6.03612 1.71435 6.12256L4.67003 13.8892C4.70511 13.9822 4.78809 14.0505 4.88818 14.0719C4.90871 14.0769 4.9301 14.0785 4.95148 14.0785ZM12.3035 6.1489L5.06868 13.2635L2.32859 6.06328L4.76756 2.57926L12.3035 6.1489Z"
      fill={color}
    />
    <path
      d="M11.0485 14.0785C11.069 14.0785 11.0904 14.076 11.1118 14.0719C11.2119 14.0513 11.2948 13.9822 11.3299 13.8892L14.2856 6.12338C14.319 6.03694 14.3061 5.93979 14.2531 5.86323L11.5823 2.04908C11.4984 1.92971 11.3359 1.88772 11.2016 1.95194L3.06087 5.80807C2.97447 5.84924 2.91458 5.92662 2.89833 6.018C2.88207 6.10938 2.91201 6.20241 2.9796 6.26827L10.8354 13.9929C10.8911 14.0481 10.9689 14.0785 11.0485 14.0785ZM13.6705 6.06246L10.9304 13.2627L3.69563 6.14808L11.2315 2.57926L13.6705 6.06246Z"
      fill={color}
    />
  </svg>
);

export default VideaLogo;
